import { useTranslation } from "react-i18next";

type TitleProp = {
  classname: string;
};

/**
 * Title of mailbox group page.
 *
 * @param classname tailwind classname
 *
 * @returns a JSX element represnting title of mailbox group page.
 */
const Title = ({ classname }: TitleProp) => {
  const { t } = useTranslation();
  const incomingClassName: string = classname || "";
  return (
    <div
      className={`font-ibm-plex-sans text-[26px] leading-[34px] ${incomingClassName}`}
    >
      {t(`Send us a secure message!`)}
    </div>
  );
};

type GroupDescriptionProp = {
  classname?: string;
  text?: string;
};

/**
 * Group description of mailbox group page. If admin of the organization has not set
 * group description then a default informative text about mailbox group page is shown.
 *
 * @param classname tailwind classname
 * @param text group description. It could be undefined or null, if admin has not set description.
 *
 * @returns a JSX element representing either group description or informative text about the page.
 */
const GroupDescription = ({ classname, text }: GroupDescriptionProp) => {
  const { t } = useTranslation();
  const incomingClassName: string = classname || "";
  const defaultDescriptionText: string = t(
    `Send a message to any member of our team and we will get back to you as soon as possible!`
  );
  const descriptionText: string = text || defaultDescriptionText;

  return (
    <div
      className={`${incomingClassName} whitespace-pre-wrap break-words font-ibm-plex-sans text-[12px] leading-[15px]`}
    >
      {descriptionText}
    </div>
  );
};

type RecipientsSectionHeaderProp = {
  classname?: string;
};

/**
 * Instructional text to select a recipient.
 *
 * @param classname tailwind classname
 * @returns a JSX element containing text instruucting user to select recipient.
 */
const RecipientsSectionHeader = ({
  classname,
}: RecipientsSectionHeaderProp) => {
  const { t } = useTranslation();
  const incomingClassName: string = classname || "";
  return (
    <div className={`${incomingClassName} font-ibm-plex-sans text-xl`}>
      {t(`Please select a recipient:`)}
    </div>
  );
};

export { Title, GroupDescription, RecipientsSectionHeader };
